<template>
  <div class="d-flex justify-center actions-bar">
    <NewApplicationQuestionTemplateDialog
      @close="closeDialog"
      :isOpen="isOpen"
    />
    <SecondaryButton
      @click.native="openDialog"
      permission="create"
      color="primary"
    >
      <div class="d-flex align-center justify-center">
        <v-img contain src="@/assets/svg/question-template-white-icon.svg" />
        <v-icon small>mdi-plus</v-icon>
      </div>
      New Application Question
    </SecondaryButton>
  </div>
</template>

<script>
import SecondaryButton from "@/components/common/Button/SecondaryButton";
import NewApplicationQuestionTemplateDialog from "../dialogs/NewApplicationQuestionTemplateDialog";

export default {
  components: {
    SecondaryButton,
    NewApplicationQuestionTemplateDialog
  },
  data() {
    return {
      isOpen: false
    };
  },
  methods: {
    openDialog() {
      this.isOpen = true;
    },
    closeDialog() {
      this.isOpen = false;
      this.$emit("refresh");
    }
  }
};
</script>
<style lang="scss"></style>
